import { styled } from '@mui/material/styles'
import { createSvgIcon } from '@mui/material/utils'
import React from 'react'

const CommunityIcon = () => {
  return (
    <svg
      width="32"
      height="16"
      viewBox="0 0 32 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33333 9.33333C6.8 9.33333 8 8.13333 8 6.66667C8 5.2 6.8 4 5.33333 4C3.86667 4 2.66667 5.2 2.66667 6.66667C2.66667 8.13333 3.86667 9.33333 5.33333 9.33333ZM6.84 10.8C6.34667 10.72 5.85333 10.6667 5.33333 10.6667C4.01333 10.6667 2.76 10.9467 1.62667 11.44C0.64 11.8667 0 12.8267 0 13.9067V16H6V13.8533C6 12.7467 6.30667 11.7067 6.84 10.8ZM26.6667 9.33333C28.1333 9.33333 29.3333 8.13333 29.3333 6.66667C29.3333 5.2 28.1333 4 26.6667 4C25.2 4 24 5.2 24 6.66667C24 8.13333 25.2 9.33333 26.6667 9.33333ZM32 13.9067C32 12.8267 31.36 11.8667 30.3733 11.44C29.24 10.9467 27.9867 10.6667 26.6667 10.6667C26.1467 10.6667 25.6533 10.72 25.16 10.8C25.6933 11.7067 26 12.7467 26 13.8533V16H32V13.9067ZM21.6533 10.2C20.0933 9.50667 18.1733 9 16 9C13.8267 9 11.9067 9.52 10.3467 10.2C8.90667 10.84 8 12.28 8 13.8533V16H24V13.8533C24 12.28 23.0933 10.84 21.6533 10.2ZM10.76 13.3333C10.88 13.0267 10.9333 12.8133 11.9733 12.4133C13.2667 11.9067 14.6267 11.6667 16 11.6667C17.3733 11.6667 18.7333 11.9067 20.0267 12.4133C21.0533 12.8133 21.1067 13.0267 21.24 13.3333H10.76ZM16 2.66667C16.7333 2.66667 17.3333 3.26667 17.3333 4C17.3333 4.73333 16.7333 5.33333 16 5.33333C15.2667 5.33333 14.6667 4.73333 14.6667 4C14.6667 3.26667 15.2667 2.66667 16 2.66667ZM16 0C13.7867 0 12 1.78667 12 4C12 6.21333 13.7867 8 16 8C18.2133 8 20 6.21333 20 4C20 1.78667 18.2133 0 16 0Z"
        fill="black"
      />
    </svg>
  )
}

export default styled(CommunityIcon)`
  position: relative;
  top: 5px;
`
